module.exports = __webpack_public_path__ + "static/homepage-hero-bg-d-4e56bbf4512926d7f20c26ab204e72e2.jpg";